export class GdsgBigtableStorageTypeBytes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageType",
            "baseName": "storageType",
            "type": "string",
            "format": ""
        },
        {
            "name": "bytesUsed",
            "baseName": "bytesUsed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "observedAtMs",
            "baseName": "observedAtMs",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgBigtableStorageTypeBytes.attributeTypeMap;
    }
    constructor() {
    }
}
